import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="section-padding bg-background-50">
      <div className="section-container">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            深度爆料
          </h2>
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-time-line"></i>
            持续更新中
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {/* First card - featured, spans 2 cols on lg */}
          <div className="sm:col-span-2 lg:col-span-2 group cursor-pointer">
            <div className="rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 h-full">
              <div className="flex flex-col lg:flex-row h-full">
                <div className="lg:w-3/5 h-48 lg:h-full min-h-[240px]">
                  <img
                    src={cardItems[0].image}
                    alt={cardItems[0].title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="lg:w-2/5 p-5 md:p-6 flex flex-col justify-center">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-[10px] font-bold mb-3 whitespace-nowrap">
                    {cardItems[0].tag}
                  </span>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {cardItems[0].title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {cardItems[0].description}
                  </p>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                    <span>{cardItems[0].time}</span>
                    <span className="text-primary-500 font-semibold">{cardItems[0].heat}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Rest of cards */}
          {cardItems.slice(1).map((item, i) => (
            <div key={i + 1} className="group cursor-pointer">
              <div className="rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 h-full">
                <div className="h-44 md:h-48">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100/80 text-accent-700 text-[10px] font-bold mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                  <div className="flex items-center gap-3 mt-2.5 text-xs text-foreground-500">
                    <span>{item.time}</span>
                    <span className="text-primary-500 font-semibold">{item.heat}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}